export const SUPER_HEALTHY = 5
export const HEALTHY = 4
export const FAIRLY_HEALTHY = 3
export const FEW_HEALTH_ISSUES = 2
export const MAJOR_HEALTH_ISSUES = 1

export const HEALTH_ADJECTIVE_CHOICES = {
    [SUPER_HEALTHY]: "Super Healthy",
    [HEALTHY]: "Healthy",
    [FAIRLY_HEALTHY]: "Fairly Healthy",
    [FEW_HEALTH_ISSUES]: "Few Health Issues",
    [MAJOR_HEALTH_ISSUES]: "Major Health Issues",
};

export const HEALTH_SUBJECT_CHOICES = {
    [SUPER_HEALTHY]: "Perfect Health",
    [HEALTHY]: "Good Health",
    [FAIRLY_HEALTHY]: "Fairly Good Health",
    [FEW_HEALTH_ISSUES]: "A Few Health Issues",
    [MAJOR_HEALTH_ISSUES]: "Major Health Issues",
};

export const HEALTH_VALUES = Object.keys(HEALTH_ADJECTIVE_CHOICES);

export const HEALTH_VALUES_FOR_SMOKERS = [
  HEALTHY,
  FEW_HEALTH_ISSUES,
  MAJOR_HEALTH_ISSUES
];
